<section
  class="toggle-Slider toggle-form document-template-slider"
  [ngClass]="{ active: isDocumentTemplateSliderOpen }"
>
  <div class="formwrap">
    <p-panel header="{{ documentTemplateHeaderText }}">
      <ng-template pTemplate="icons">
        <p-button
        appPreventDoubleClick
          styleClass="p-button-text"
          id="documentTemplateCloseBtn"
          type="button"
          label="Close"
          class="align-right"
          (debounceClick)="openConfirmationModal()"
        ></p-button>
      </ng-template>
      <div
        *ngIf="errorMessages.length > 0"
        class="documentTemplateSliderErrorMessagePlaceHolder"
      >
        <p-messages severity="error">
          <ng-template pTemplate>
            <div>
              <span class="p-message-icon pi pi-times-circle"></span>
              <span class="p-ml-2">{{ errorMessageHeaderText }}</span>
            </div>
            <div>
              <ul>
                <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
              </ul>
            </div>
          </ng-template>
        </p-messages>
      </div>
      <div class="mt-3">
        <bpt-text-input
          label="Name*"
          [highlightAllOnFocus]="true"
          [(ngModel)]="documentTemplateName"
          id="documentTemplateName"
          (textInputKeyUp)="enableOrDisableSaveButton()"
          [ngClass]="{ 'error-highlight': !isDocumentTemplateNameValid }"
          placeholder="Document Template Name"
        ></bpt-text-input>
      </div>
      <div class="mt-3">
        <bpt-file-upload
          [disabled]="disableFileUploader"
          [uploadFiles]="uploadSucceeds"
          [deleteFile]="deleteFile"
          [maxSize]="maxFileSize"
          [fileNames]="savedFiles"
          [fileTypes]="documentTemplateFileTypes"
          [fileLimit]="maxFileLimit"
        ></bpt-file-upload>
      </div>
      <p-button
      appPreventDoubleClick
        [disabled]="documentTemplateIsSaveDisable"
        label="Save"
        type="submit"
        id="documentTemplateSaveButton"
        styleClass="bpt-button-compact"
        class="align-right mr-3"
        (debounceClick)="saveDocumentTemplate()"
      >
      </p-button>
    </p-panel>
  </div>
</section>
